<template>
  <MaskLayer v-if="isOpen">
    <div class="float-bottom w-100 bg-white d-flex flex-column position-fixed animate__animated animate__slideInUp overflow-hidden" style="height:90%;bottom:0;">
      <a href="javascript:void(0)" @click="close" class="icon-animate position-absolute" style="right:0;top:0;z-index:10;"><span class="material-icons">close</span></a>
      <slot />
    </div>
  </MaskLayer>
</template>
<script>
import MaskLayer from '@/components/MaskLayer.vue';

export default {
  components: { MaskLayer },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('update:isOpen', false);
    },
  },
};
</script>
